import { render, staticRenderFns } from "./DrawerEditProfile.vue?vue&type=template&id=01512408"
import script from "./DrawerEditProfile.vue?vue&type=script&lang=js"
export * from "./DrawerEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports